import React from 'react';

import { mapDefaultRemoteOptions, mapPayeeOptions } from '../../../Helper';
import { FormTypeOption, FormTypeOptionComponentProps } from '../../../types/treatment';
import Form from '../Form/Form';

const mapRemoteOptions = (responseData) => {
  const payees = mapPayeeOptions(responseData.vendors, responseData.employees);
  const defaultRemoteOptions = mapDefaultRemoteOptions(responseData);

  return {
    ...defaultRemoteOptions,
    payees,
  };
};

export const DISABLED_FIELDS = {
  isMethodDisabled: true,
  isAccountDisabled: true,
  isTermsDisabled: true,
  isDueOnDisabled: true,
};

const REQUIRED_FIELDS = {
  isMethodRequired: false,
  isAccountRequired: false,
  isTermsRequired: false,
  isDueOnRequired: false,
};

const BaseForm = ({ register, control, dropdowns }: FormTypeOptionComponentProps) => {
  return (
    <Form
      register={register}
      control={control}
      dropdowns={dropdowns}
      disabledFields={DISABLED_FIELDS}
      requiredFields={REQUIRED_FIELDS}
    />
  );
};

export default BaseForm;

export const title = 'Base';
const optionName = 'Base';
const id = 'Base';

export const BaseFormOption: FormTypeOption = {
  id,
  title,
  optionName,
  Component: BaseForm,
  mapRemoteOptions,
  disabledFields: DISABLED_FIELDS,
  requiredFields: REQUIRED_FIELDS,
};
